import angular from 'angular'

import { includes } from 'lodash-es'

import Emitter from './emitter'
import MapSimple from './map-simple'

angular
  .module('ggs.utils')
  .factory('DataChannel', DataChannelProvider)

function DataChannelProvider() {
  const name2channel = MapSimple()

  return DataChannel

  function DataChannel(name) {
    return name2channel.has(name)
      ? name2channel.get(name)
      : name2channel.set(name, Channel(name))
  }

  function Channel(name) {
    const emitter = Emitter(`dataChannel::${name}`).setMaxListeners(1000)
    const entries = []
    const channel = {
      add,
      name,
      emitter,
      entries
    }

    return channel

    function add(entry) {
      if (!includes(entries, entry)) {
        entries.push(entry)
        emitter.emit(entry)
      }
      return channel
    }
  }
}
